module.exports = __webpack_public_path__ + "05_glasses_black.c32a5ce4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer4/05_glasses_black.png
// module id = qC6g
// module chunks = 0